import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Tabs } from "antd";
import { DownloadOutlined, TagsOutlined, FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";
import movimientoInventarioPdf from "../Pdf/movimientoInventarioPdf";
import etiquetasMovimientoInventarioPdf from "../Pdf/etiquetasMovimientoInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const IFRAME_NAME = "MovimientosInventarioNotifIframe";

class ModalNotificacionMovimientosInventarioGlobal extends Component {
  state = {
    visible: false,
    loading: false,
    movimientos: [],
    activeKey: "0",
    vistaPorTab: {}, // { [idx]: "movimiento" | "etiquetasCon" | "etiquetasSin" }
  };

  componentDidMount() {
    window.mostrarMovimientosInventarioPdf = this.abrir;
  }

  componentWillUnmount() {
    if (window.mostrarMovimientosInventarioPdf === this.abrir) {
      delete window.mostrarMovimientosInventarioPdf;
    }
    if (this.esperaTimeout) clearTimeout(this.esperaTimeout);
  }

  hayOtroModalAbierto = () => {
    if (this.state.visible) return false;
    const masks = document.querySelectorAll(".ant-modal-mask");
    return Array.from(masks).some((m) => {
      const style = window.getComputedStyle(m);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  };

  abrir = (movimientosIds) => {
    if (!Array.isArray(movimientosIds) || movimientosIds.length === 0) return;
    this.pendingIds = movimientosIds;
    if (this.esperaTimeout) clearTimeout(this.esperaTimeout);
    this.esperaTimeout = setTimeout(this.intentarAbrir, 150);
  };

  intentarAbrir = () => {
    if (this.hayOtroModalAbierto()) {
      this.esperaTimeout = setTimeout(this.intentarAbrir, 400);
      return;
    }
    const ids = this.pendingIds;
    this.pendingIds = null;
    if (!ids) return;
    this.realmenteAbrir(ids);
  };

  realmenteAbrir = (movimientosIds) => {
    this.setState({
      visible: true,
      loading: true,
      movimientos: [],
      activeKey: "0",
    });

    axios
      .post(
        "movimientosInventario/datosPdfMovimientosInventario",
        { movimientosIds, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2 && Array.isArray(res.data.movimientos)) {
          const empresa = res.data.empresa;
          const movimientos = res.data.movimientos.map((m, idx) => {
            const folio =
              m.serieNumero ||
              `${m.serie ? m.serie + "-" : ""}${m.folio || idx + 1}`;
            const dd = movimientoInventarioPdf({ movimiento: m, empresa });
            const pdf = pdfMake.createPdf(dd);
            return {
              folio,
              pdf,
              movimiento: m,
              empresa,
              esSalida: !!m.esSalida,
              pdfsEtiquetas: {},
            };
          });
          this.setState(
            { loading: false, movimientos, activeKey: "0", vistaPorTab: {} },
            () => {
              this.previewActivo("0");
            }
          );
        } else {
          message.error("No se pudieron cargar los movimientos de inventario");
          this.setState({ loading: false, visible: false });
        }
      })
      .catch(() => {
        message.error("Error al consultar movimientos de inventario");
        this.setState({ loading: false, visible: false });
      });
  };

  getPdfActivo = async (idx) => {
    const item = this.state.movimientos[idx];
    if (!item) return null;
    const vista = this.state.vistaPorTab[idx] || "movimiento";
    if (vista === "movimiento") return item.pdf;
    if (item.pdfsEtiquetas[vista]) return item.pdfsEtiquetas[vista];
    const conDatosEmpresa = vista === "etiquetasCon";
    const dd = await etiquetasMovimientoInventarioPdf(
      { movimiento: item.movimiento, empresa: item.empresa },
      { conDatosEmpresa }
    );
    const pdf = pdfMake.createPdf(dd);
    item.pdfsEtiquetas[vista] = pdf;
    return pdf;
  };

  previewActivo = async (key) => {
    const idx = Number(key);
    const pdf = await this.getPdfActivo(idx);
    if (pdf && window.frames[IFRAME_NAME]) {
      pdf.open({}, window.frames[IFRAME_NAME]);
    }
  };

  cambiarTab = (key) => {
    this.setState({ activeKey: key }, () => this.previewActivo(key));
  };

  cambiarVista = (vista) => {
    const idx = Number(this.state.activeKey);
    this.setState(
      (st) => ({ vistaPorTab: { ...st.vistaPorTab, [idx]: vista } }),
      () => this.previewActivo(this.state.activeKey)
    );
  };

  descargarActivo = async () => {
    const idx = Number(this.state.activeKey);
    const item = this.state.movimientos[idx];
    if (!item) return;
    const vista = this.state.vistaPorTab[idx] || "movimiento";
    const pdf = await this.getPdfActivo(idx);
    if (!pdf) return;
    const prefijo =
      vista === "movimiento" ? "MovimientoInventario" : "Etiquetas";
    pdf.download(`${prefijo}_${item.folio}.pdf`);
  };

  descargarTodos = () => {
    this.state.movimientos.forEach((item) => {
      item.pdf.download(`MovimientoInventario_${item.folio}.pdf`);
    });
  };

  cerrar = () => {
    this.setState({
      visible: false,
      movimientos: [],
      activeKey: "0",
      vistaPorTab: {},
    });
  };

  render() {
    const { visible, loading, movimientos, activeKey, vistaPorTab } = this.state;
    const titulo =
      movimientos.length > 1
        ? `Movimientos de Inventario (${movimientos.length})`
        : "Movimiento de Inventario";
    const idxActivo = Number(activeKey);
    const itemActivo = movimientos[idxActivo];
    const vistaActiva = vistaPorTab[idxActivo] || "movimiento";
    const puedeEtiquetar = !!itemActivo;

    return (
      <ModalItem
        title={titulo}
        visible={visible}
        spinning={loading}
        onCancel={this.cerrar}
        paddingTop
        width={900}
        footer={null}
      >
        {movimientos.length > 1 && (
          <Tabs
            activeKey={activeKey}
            onChange={this.cambiarTab}
            size="small"
            style={{ marginBottom: 6 }}
          >
            {movimientos.map((m, i) => (
              <Tabs.TabPane tab={m.folio} key={String(i)} />
            ))}
          </Tabs>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <ButtonItem
              icon={<FilePdfOutlined />}
              cyan={vistaActiva === "movimiento"}
              blanco={vistaActiva !== "movimiento"}
              onClick={() => this.cambiarVista("movimiento")}
              disabled={!itemActivo}
            >
              Movimiento
            </ButtonItem>
            {puedeEtiquetar && (
              <>
                <ButtonItem
                  icon={<TagsOutlined />}
                  cyan={vistaActiva === "etiquetasCon"}
                  blanco={vistaActiva !== "etiquetasCon"}
                  onClick={() => this.cambiarVista("etiquetasCon")}
                >
                  Etiquetas con empresa
                </ButtonItem>
                <ButtonItem
                  icon={<TagsOutlined />}
                  cyan={vistaActiva === "etiquetasSin"}
                  blanco={vistaActiva !== "etiquetasSin"}
                  onClick={() => this.cambiarVista("etiquetasSin")}
                >
                  Etiquetas sin empresa
                </ButtonItem>
              </>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={this.descargarActivo}
              disabled={!movimientos.length}
            >
              {movimientos.length > 1 ? "Descargar este" : "Descargar PDF"}
            </ButtonItem>
            {movimientos.length > 1 && (
              <ButtonItem
                icon={<DownloadOutlined />}
                onClick={this.descargarTodos}
              >
                Descargar todos ({movimientos.length})
              </ButtonItem>
            )}
            <ButtonItem danger onClick={this.cerrar}>
              Cerrar
            </ButtonItem>
          </div>
        </div>

        <iframe
          title="Movimiento Inventario PDF"
          style={{
            width: "100%",
            height: "75vh",
            border: "1px solid #d9d9d9",
          }}
          id={IFRAME_NAME}
          name={IFRAME_NAME}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(
  ModalNotificacionMovimientosInventarioGlobal
);
